import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useTeamTableStore,
  initialTeamColumns,
} from 'views/pages/Admin/Teams/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type TeamColumnKey =
  | 'name'
  | 'description'
  | 'city'
  | 'managing_entity'
  | 'other_assignments'
  | 'user_count'
  | 'lead_user'
  | 'patient_count';

const TEAM_TABLE_COLUMN_LABELS: Record<TeamColumnKey, string> = {
  name: 'Name',
  description: 'Description',
  city: 'City / State',
  managing_entity: 'Managing Entity',
  other_assignments: 'Other Assignments',
  user_count: 'Users',
  lead_user: 'Lead User',
  patient_count: 'Patients',
};

const ALL_FIELDS = initialTeamColumns.map(c => c.field) as TeamColumnKey[];

export const TeamTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useTeamTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useTeamTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<TeamColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<TeamColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='team_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={TEAM_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
